import { render, staticRenderFns } from "./FormInvoiceDetail.vue?vue&type=template&id=4c4e2406&"
import script from "./FormInvoiceDetail.vue?vue&type=script&lang=js&"
export * from "./FormInvoiceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports